import { MapPin, Calendar, Users } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useLanguage } from "@/hooks/useLanguage";

const iconMap = [MapPin, Calendar, Users];

const AboutStory = () => {
  const { t, tObject } = useLanguage();
  const stats = tObject<Array<{ value: string; label: string }>>("aboutStory.stats");

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6">{t("aboutStory.title")}</h2>
            <div className="space-y-4 text-lg text-muted-foreground">
              <p>{t("aboutStory.p1")}</p>
              <p>{t("aboutStory.p2")}</p>
              <p className="text-foreground font-medium">{t("aboutStory.p3")}</p>
            </div>
          </div>

          <div className="space-y-4">
            {stats.map((stat, index) => {
              const Icon = iconMap[index] || MapPin;
              return (
                <Card key={index} className="border-border/50 hover:shadow-md transition-shadow">
                  <CardContent className="p-6 flex items-center gap-4">
                    <div className="w-14 h-14 bg-accent/10 rounded-xl flex items-center justify-center shrink-0">
                      <Icon className="w-7 h-7 text-accent" />
                    </div>
                    <div>
                      <div className="text-2xl font-bold text-primary">{stat.value}</div>
                      <div className="text-muted-foreground">{stat.label}</div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutStory;
